// extracted by mini-css-extract-plugin
export default {"contactFooter":"lsCNJ_lsCNJ","contactBtn":"CrIXv_CrIXv"};